<template>
  <div>
    <homePage></homePage>
    <homePage1></homePage1>
    <homePage2></homePage2>
    <homePage3></homePage3>
    <homePage4 id="efficiency"></homePage4>
    <homePage5></homePage5>
    <homePage6 id="scale"></homePage6>
    <footerBox></footerBox>
  </div>
</template>

<script>
import homePage from "../views/homepage/homePage.vue"
import homePage1 from "../views/homepage/homePage1.vue"
import homePage2 from "../views/homepage/homePage2.vue"
import homePage3 from "../views/homepage/homePage3.vue"
import homePage4 from "../views/homepage/homePage4.vue"
import homePage5 from "../views/homepage/homePage5.vue"
import homePage6 from "../views/homepage/homePage6.vue"
import footerBox from "../components/footerBox.vue"
export default {
  components: {
    homePage,
    homePage1,
    homePage2,
    homePage3,
    homePage4,
    homePage5,
    homePage6,
    footerBox,
  },
  data() {
    return {}
  },
}
</script>

<style scoped></style>
